export const replaceValuesForPasswordError = value => {
  const { plain_password: password, ...rest } = value;

  return { ...rest, password };
};
